import { ref } from 'vue';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';

export function useFetchKioskNotLogout() {
    const data = ref(null);
    const error = ref(null);
    const loading = ref(false);

    async function fetchKioskNotLogout(employeeId, shiftName) {
        loading.value = true;
        data.value = null;
        error.value = null;

        try {
            const response = await axiosClient.get(
                API_ENDPOINTS.fetchKioskNotLogoutById.replace('{employeeId}', employeeId).replace('{shiftName}', shiftName)
            );
            data.value = response.data[0]; // Assuming the API always returns an array with one item
        } catch (err) {
            console.error('Error fetching kiosk not logout:', err);
            error.value = 'Failed to fetch not logout data';
            if (axiosClient.isAxiosError(err)) {
                if (err.response) {
                    console.error('Error response:', err.response.data);
                    console.error('Error status:', err.response.status);
                    error.value = `Server error: ${err.response.status}`;
                } else if (err.request) {
                    console.error('Error request:', err.request);
                    error.value = 'No response from server';
                } else {
                    console.error('Error message:', err.message);
                    error.value = err.message;
                }
            }
        } finally {
            loading.value = false;
        }
    }

    return { data, error, loading, fetchKioskNotLogout };
}